import axios, { AxiosError, AxiosInstance } from 'axios';
import { TokenType } from 'data/token';

interface CustomInstance extends AxiosInstance {
  get<T>(...params: Parameters<AxiosInstance['get']>): Promise<T>;
  post<T>(...params: Parameters<AxiosInstance['post']>): Promise<T>;
}

const useParkingAxios = () => {
  const api: CustomInstance = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
    headers: {
      accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });

  api.interceptors.request.use(
    async config => {
      const requestConfig = config;
      requestConfig.headers.Authorization = `Bearer ${localStorage.getItem(TokenType.DESKTOP)}`;
      return config;
    },
    error => Promise.reject(error),
  );

  api.interceptors.response.use(
    response => response.data.data,
    (error: AxiosError) => error,
  );
  return { api };
};

export default useParkingAxios;
